import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { AgentConversation } from '@/agent/conversations/store/slice'

type ConversationNavigationState = {
  lastViewedByMatter: Partial<{ [matterId: string]: string }>
}

const initialState: ConversationNavigationState = {
  lastViewedByMatter: {},
}

/**
 * Conversation Navigation Slice
 * Holds matter-aware navigation state for conversations
 */
export const conversationNavigationSlice = createSlice({
  name: 'conversationNavigationState',
  initialState,
  reducers: {
    // ============== Slice Actions ============== >
    nullifyData: () => initialState,

    // Set the last viewed conversation for a given matter
    setLastViewedByMatter: (
      state,
      action: PayloadAction<{
        conversation: AgentConversation
        activeMatterId: string | null
      }>
    ) => {
      const { conversation, activeMatterId } = action.payload

      // Must have a matter selected and the conversation must belong to it
      if (!activeMatterId || !conversation || conversation.matter_id !== activeMatterId) return

      if (state.lastViewedByMatter[activeMatterId] === conversation.id) return

      state.lastViewedByMatter[activeMatterId] = conversation.id
    },
  },
})

// Actions
export const ConversationNavigationActions = conversationNavigationSlice.actions

export default conversationNavigationSlice.reducer
